<template>
  <div class="page">
    <van-sticky>
      <van-nav-bar title="绑定账户" left-arrow @click-left="goBack" />
    </van-sticky>
    <div class="nav">
      <div class="card" v-if="bindAccountList.length === 0">
        <div class="card-left">
          <h3>添加微信账号</h3>
          <p>
            通过您的微信账户，普惠平台将提现的金额
            转入您微信账户中绑定的银行卡中。
          </p>
        </div>
        <div class="card-right" @click="goTobind">
          <van-icon name="add-o" />
        </div>
      </div>

      <div v-else class="have-account">
        <div class="account">
          <div class="account-left">
            <div class="img">
              <img :src="bindAccount.headImgUrl" alt="" />
            </div>
            <div class="name">{{ bindAccount.nickname }}</div>
          </div>
          <div class="account-right">已绑定微信账号</div>
        </div>
        <div class="account">
          <div class="msg">
            <p>收账人姓名：{{ bindAccount.realName }}</p>
            <p>微信账号：{{ bindAccount.nickname }}</p>
          </div>
          <div class="btn">
            <van-button size="normal" @click="untie">解绑账号</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bindAccounts, unbindAccounts } from '@/api/gold-coin'

export default {
  data() {
    return {
      bindAccount: '',
      bindAccountList: [],
    }
  },
  created() {
    this.getBindAccountsInfo()
  },
  methods: {
    getBindAccountsInfo() {
      bindAccounts().then(({ data }) => {
        if (data.code === 200) {
          this.bindAccount = data.data[0]
          this.bindAccountList = data.data
          console.log('bind', data.data)
        }
      })
    },
    untie() {
      this.$dialog.confirm({
        title: '提示',
        message: '解绑当前微信账户，佣金无法进行结算,确定解绑该账户吗',
      })
        .then(() => {
          unbindAccounts().then(({ data }) => {
            if (data.code === 200) {
              this.$toast('解绑成功')
              this.getBindAccountsInfo()
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
    goTobind() {
      this.$router.replace({ path: '/gold-coin/binding' })
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f4f4f4;
}
.nav {
  padding: 10px;
}
.card {
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  .card-left {
    width: 240px;
    h3 {
      margin: 5px 0;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 11px;
      color: #323233;
    }
    p {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 18px;
      color: #969799;
    }
  }
}
.card-right {
  font-size: 30px;
  color: #0099cc;
  padding: 10px;
}
.have-account {
  padding: 10px;
  background: #fff;
  border-radius: 8px;
}
.account-left {
  display: flex;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0);
    border: 1px solid #c8c9cc;
    border-radius: 50%;
  }
  .name {
    margin-left: 8px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 11px;
    color: #323233;
  }
}
.account-right {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #0099cc;
}
.account {
  display: flex;
  justify-content: space-between;
}
.msg {
  p {
    margin: 5px;
  }
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #646566;
}
.btn {
  .van-button--normal {
    margin-top: 20px;
    width: 64px;
    height: 25px;
    background: #ffffff;
    border: 1px solid #ee0a24;
    opacity: 1;
    border-radius: 5px;
    padding: 0;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 18px;
    color: #ee0a24;
  }
}
</style>